var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"center"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h2',[_vm._v("Page Not Found")])])])
}]

export { render, staticRenderFns }